import { CSSProperties, ReactNode } from 'react';
import { ThemeKey } from 'types/general.types';

import PantheonNorgreen from 'assets/campaignImages/PantheonNorgreen.webp';

interface CampaignConfig {
  title: string;
  mainText: ReactNode;
  image?: string;
  imageStyle?: CSSProperties;
  primaryButtonText: string;
  secondaryButtonText?: string;
  route?: string;
}

export const campaign: Partial<Record<ThemeKey, CampaignConfig>> = {
  [ThemeKey.PANTHEON]: {
    image: PantheonNorgreen,
    imageStyle: {
      width: '100%',
      maxHeight: 320,
      objectFit: 'cover',
      objectPosition: 'bottom',
      borderRadius: 8,
    },
    title: 'New Project live: Norway - Norgreen Facility',
    mainText: `A renewable-driven project built to utilise Norway's strong energy advantages for Bitcoin mining. \
The operation benefits from the country's stable climate, reliable infrastructure and \
low-carbon energy mix dominated by hydropower. The site integrates with a local district heating system, \
reusing waste heat to support the community and reduce overall emissions.\n
Secure your fully-managed miners before the project sells out.`,
    primaryButtonText: 'Claim your spot now!',
    route: '/shop',
  },
  [ThemeKey.CRYPTOHALL24_DUERR]: {
    title: 'New available Miners',
    mainText: `We regularly add new miners at new locations. Explore our shop to discover the latest 
    miners and exclusive promotions. Purchase directly from your dashboard and start mining in just a few clicks.`,
    primaryButtonText: 'Discover available Miners',
    route: '/shop',
  },
  [ThemeKey.CRYPTOHALL24_QUETTA]: {
    title: 'New available Miners',
    mainText: `We regularly add new miners at new locations. Explore our shop to discover the latest 
    miners and exclusive promotions. Purchase directly from your dashboard and start mining in just a few clicks.`,
    primaryButtonText: 'Discover available Miners',
    route: '/shop',
  },
};
